module.exports = __webpack_public_path__ + "img/IMG_1454_L_WoodMatted.0ee0d761.jpg";